import React from 'react';
import {StyleSheet, View, TouchableOpacity} from 'react-native';

import {observer} from 'mobx-react';
import {useNavigation} from '@react-navigation/native';

import {SVGIcon, RNEText} from '../../components';

import {colorPalette} from '../../../core/config/color.config';

import {ConsultationRequestResBody} from '../../server/types/consultation.types';

import ConsultationPhoto from '../consultation/ConsultationPhoto';

import {PopoverItemKey} from '../popover/data/popoverItems.data';
import { width, height, totalSize } from 'react-native-dimension';
import {getFullNameLastNameFirst} from '../../utils/common.utils';

interface HeaderConsultationDoctorProps {
  serviceRequest?: ConsultationRequestResBody;
  onMenuItemClick?: (itemKey: PopoverItemKey) => void;
  onBackClickFromList?: () => void;
}

const HeaderConsultationDoctor = (props: HeaderConsultationDoctorProps) => {
  const navigation = useNavigation();

  const onBackClick = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  };

  return (
    <View accessibilityRole="button" style={styles.mainContainer}>
      <TouchableOpacity
        activeOpacity={0.75}
        onPress={
          props.onBackClickFromList ? props.onBackClickFromList : onBackClick
        }>
        <View style={styles.backContainer}>
          <SVGIcon name="left-gray" size={20} />
        </View>
      </TouchableOpacity>

      <View style={styles.profileContainer}>
        <View style={styles.profilePhoto}>
          <ConsultationPhoto
            photo={props.serviceRequest?.performer?.photo}
            size={totalSize(4.5)}
          />
        </View>

        <View style={styles.nameProfessionContainer}>
          <RNEText
            label={
              props.serviceRequest?.performer
                ? `Dr. ${getFullNameLastNameFirst(
                    props.serviceRequest.performer.humanName,
                  )}`
                : '--'
            }
            variant="button"
            // weight="bold"
            numberOfLines={2}
            style={{fontFamily:'Quicksand-Bold', fontSize: totalSize(1.5)}}
          />
          <RNEText
            label={
              props.serviceRequest?.performer
                ? `${
                    props.serviceRequest?.performer?.practitionerRole?.[0]
                      .specialty.text || '--'
                  }`
                : '--'
            }
            variant="button"
            // weight="300"
            color="blackLight"
            numberOfLines={1}
            style={{fontFamily:'Quicksand-Regular', fontSize: totalSize(1.4)}}
          />
        </View>
      </View>
    </View>
  );
};

export default observer(HeaderConsultationDoctor);

const styles = StyleSheet.create({
  mainContainer: {
    paddingHorizontal: 20,
    flexDirection: 'row',
    alignItems: 'center',
    width: width(60),
  },
  backContainer: {
    marginRight: 16,
  },
  profileContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  profilePhoto: {
    // borderRadius: 50,
    // borderWidth: 1,
    // borderColor: colorPalette.primary,
    width: 36,
    height: 36,
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageStyle: {
    height: 36,
    width: 36,
    borderRadius: 100,
    borderWidth: 1,
    borderColor: colorPalette.primary,
  },
  nameProfessionContainer: {
    marginLeft: 16,
    flex: 1,
    minWidth: 0,
  },
});
